<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="d-flex align-items-center flex-column flex-md-row">
            <bita-bootbutton
              type="primary"
              title="افزودن راننده"
              icon="fas fa-plus-square"
              class="col-12 col-md-2"
              @click.native="statusChangeModalCreate"
            />
            <bita-bootbutton
              type="primary"
              title="ایمپورت فایل اکسل"
              icon="fas fa-plus-square"
              class="col-12 col-md-2 mx-2 mt-md-0 mt-3"
              @click.native="statusChangeModalImport"
            />
            <bita-input
              type="text"
              name="search"
              label="جستجو"
              rules=""
              validation-container-class="col-lg-2"
              input-class="form-control"
              v-model.lazy="filters.search"
              @change="(e) => search(e)"
            />
            <bita-select
              name="priorities"
              label="اولویت"
              ref="prioritiesDropDown"
              rules=""
              validation-container-class="col-lg-2"
              input-class="form-control"
              :data-source="priorities"
              data-text-field="priority"
              data-value-field="priority"
              v-model="filters.priority"
              @change="(e) => search(e)"
            />
            <bita-bootbutton
              type="danger"
              title="حذف فیلتر"
              class="col-lg-1 mt-3 ml-3"
              style="height: 35px"
              @click.native="reset"
            />
          </div>

          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :resizable="true"
            :page-size="pageSize"
            :current-page="currentPage"
            how-row
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="createModal"
      :isLoading="isLoadingModal"
      modal-id="create-modal"
      title="افزودن راننده"
      @on-submit="handleCreate"
    />
    <import-modal
      ref="driversModal"
      :isLoading="isLoadingModal"
      modal-id="drivers-modal"
      title="رانندگان بومی"
      @on-submit="handleImportExcel"
    />
  </div>
</template>
<script>
import DriverForm from "./Form";
import ImportExcel from "./Import";

export default {
  components: { "form-modal": DriverForm, "import-modal": ImportExcel },
  data() {
    return {
      gridColumns: [
        { field: "full_name", title: "نام", width: "160px" },
        { field: "phone", title: "شماره همراه", width: "150px" },
        { field: "national_code", title: "کدملی", width: "140px" },
        { field: "pivot.priority", title: "اولویت", width: "60px" },
        {
          title: "عملیات",
          command: [],
          width: "50px",
        },
      ],
      isLoadingForm: false,
      isLoadingGrid: false,
      isLoadingModal: false,
      pageSize: 30,
      currentPage: 1,
      filters: {
        search: "",
        priority: "",
      },
      priorities: [],
    };
  },
  mounted() {
    this.getPriorities();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
    this.loadData();
  },
  computed: {
    breadCrumbs() {
      return [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت سیستم", link: "" },
        {
          title: "مدیریت " + this.$route.query.name,
          link: "/management/salons",
          active: true,
        },
        {
          title: "مدیریت رانندگان بومی",
          active: true,
        },
      ];
    },
    salonId() {
      return this.$route.params.id;
    },
  },
  methods: {
    getPriorities() {
      this.$persistClient("get", `salons/${this.salonId}/priorities`).then(
        (res) => {
          function unique(data, key) {
            return [...new Map(data.map((x) => [key(x), x])).values()];
          }
          this.priorities = unique(res.data, (item) => item.priority);
        }
      );
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    reset() {
      this.filters.search = "";
      this.filters.priority = "";
      this.loadData();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `salons/${this.salonId}/drivers?page=${this.currentPage}&page_size=${this.pageSize}`;
      let url = this.$makeQueryStringForSpatie(baseUrl, this.filters, "&");
      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    async loadData() {
      this.$refs.grid.loadDataSource();
    },
    search: _.debounce(function() {
      this.loadData();
    }, 1000),
    delete(e) {
      let driver = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف ${driver.full_name} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient(
            "delete",
            `salons/${this.salonId}/drivers/${driver.id}`
          )
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalImport() {
      $("#drivers-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    handleImportExcel(form) {
      this.isLoadingModal = true;
      this.$persistClient(
        "post",
        `salons/${this.salonId}/drivers/excel`,
        this.$getFormData(form)
      )
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
          this.statusChangeModalImport();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    async handleCreate(form) {
      this.isLoadingModal = true;
      await this.$persistClient("post", `salons/${this.salonId}/drivers`, form)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
          this.statusChangeModalCreate();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
  },
};
</script>
